module.exports = __webpack_public_path__ + "media/assets/btn-minus-913d8b67663f9fedabb9f823578b61f7.svg";